import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { RLCharDataTableController } from "../ts/rlAdmin.chardatadirectives";
import { NotifyService } from "../services/notify-service";
import { AlertService } from "../services/alert-service";
import { Dictionary } from "lodash";
import { EntityConfigService } from "../services/entity-config-service";

export function RLViewAlertsByCharacteristic() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/view-alerts-by-characteristic.html"),
        controller: RLViewAlertsByCharacteristicController,
        controllerAs: "vaVM",
        bindToController: true,
        require: ["rlViewAlertsByCharacteristic", "?^rlCharDataTable"],
        scope: {
            charTypeID: "=charTypeId",
            templateID: "=templateId",
            charID: "=charId",
            charDataType: "=",
            charLabel: "=",
            entityID: "=entityId"
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLViewAlertsByCharacteristicController, RLCharDataTableController]) => {
            controllers[0].tableCtrl = controllers[1];
        }
    };

    return directive;
}

class RLViewAlertsByCharacteristicController {
    static $inject = [
        "$scope",
        "$q",
        "$window",
        "$filter",
        "notifyService",
        "alertService",
        "entityConfigService"
    ];

    charTypeID: number;
    charID: number;
    templateID: number;
    charDataType: number;
    charLabel: string;
    entityID: string;
    alerts: Models.IAlert[] = [];
    configAlerts: Models.IAlert[] = [];
    recAlerts: Models.IAlert[] = [];
    recID: number;

    public otherTemplateDatesLookup: Dictionary<string> = {};
    public containsOptionsLookup: Dictionary<string> = {};

    tableCtrl: RLCharDataTableController;

    constructor(private $scope: ng.IScope,
        private readonly $q: ng.IQService,
        private readonly $window: ng.IWindowService,
        private readonly $filter: ng.IFilterService,
        private readonly notifyService: NotifyService,
        private readonly alertService: AlertService,
        private readonly entityConfigService: EntityConfigService, ) {
        $scope.$watchCollection(() => [this.charTypeID, this.templateID, this.charID],
            (newValue, oldValue) => {
                if (this.charTypeID != null && this.templateID != null && this.charID != null && this.entityID != null) {
                    this.ParseEntityID(this.entityID);
                    this.LoadAlerts();
                }
            });
    }

    ParseEntityID(entityID) {
        this.recID = Utils.IdBuilder.splitEntityID(entityID).recID;
    }

    LoadAlerts() {
        this.notifyService.startProgress();

        let templatePromise = this.entityConfigService.getCharacteristicTemplate(this.charTypeID, this.templateID)
            .then(result => {
                this.otherTemplateDatesLookup = result.characteristicMetaDatas
                    .filter(x => x.dataTypeID === Consts.CharDataTypeIDs.CharDataTypes.date && x.characteristicID !== this.charID)
                    .reduce<Dictionary<string>>((lookup, next) => {
                        lookup[next.characteristicID] = next.label;
                        return lookup;
                    }, {});
            });

        let containsOptionsPromise = this.alertService.getAlertContainsValueTypeList()
            .then(result => {
                this.containsOptionsLookup = this.alertService.alertContainsValuesToLookup(result);
            });

        let alertPromise = this.alertService.getAlertList(this.charTypeID, this.templateID, this.charID, this.recID)
            .then((results) => {
                this.recAlerts = results;
                this.alertService.getConfigAlertList(this.charTypeID, this.templateID, this.charID, -1)
                    .then((results) => {
                        this.configAlerts = results;
                    })
                    .then(() => {
                        this.alerts = this.recAlerts.concat(this.configAlerts);
                    });
            });

        let promises = [templatePromise, containsOptionsPromise, alertPromise];

        return this.$q.all(promises)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    EditMode() {
        if (this.tableCtrl != undefined){
            this.tableCtrl.SetEditMode(true);
        }
    }
}
